import { computed, defineComponent, onMounted, ref, useCssModule } from '@nuxtjs/composition-api';
import { TYPES_FEEDS } from './';
export default defineComponent({
    name: 'FeedSubscription',
    props: {
        rubricType: {
            default: '',
            type: String,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const currentIndex = ref(0);
        const feeds = computed(() => TYPES_FEEDS[props.rubricType] || TYPES_FEEDS.others);
        onMounted(() => {
            currentIndex.value = Math.floor(Math.random() * feeds.value.length);
        });
        return {
            feeds,
            css,
            currentIndex,
        };
    },
});
